import { db, delay } from "./api";

export const financeService = {
  async getPayments() {
    await delay(200);
    return [...db.payments];
  },

  async recordPayment(paymentData) {
    await delay(300);
    const newPayment = {
      ...paymentData,
      id: `PAY-${Date.now()}`,
      status: "Completed",
      date: paymentData.date || new Date().toISOString().slice(0, 10)
    };

    if (paymentData.type === "Customer Receipt" && paymentData.partyId) {
      const cust = db.customers.find((c) => c.id === paymentData.partyId);
      if (cust) {
        cust.outstandingBalance = Math.max(0, (cust.outstandingBalance || 0) - Number(paymentData.amount));
      }
    } else if (paymentData.type === "Supplier Payment" && paymentData.partyId) {
      const supp = db.suppliers.find((s) => s.id === paymentData.partyId);
      if (supp) {
        supp.outstandingBalance = Math.max(0, (supp.outstandingBalance || 0) - Number(paymentData.amount));
      }
    }

    db.payments.unshift(newPayment);

    db.auditLogs.unshift({
      id: `AUD-${Date.now()}`,
      user: "Finance Officer",
      role: "Accountant / Finance",
      action: `Recorded ${newPayment.type}`,
      module: "Finance",
      timestamp: new Date().toISOString().replace("T", " ").slice(0, 19),
      details: `Settlement of ₹${Number(newPayment.amount).toLocaleString("en-IN")} via ${newPayment.paymentMethod} for ${newPayment.partyName}`
    });

    db.persistAll();
    return newPayment;
  },

  async getExpenses() {
    await delay(200);
    return [...db.expenses];
  },

  async createExpense(data) {
    await delay(300);
    const newExp = {
      ...data,
      id: `EXP-${Date.now()}`,
      date: data.date || new Date().toISOString().slice(0, 10),
      amount: Number(data.amount)
    };
    db.expenses.unshift(newExp);

    db.auditLogs.unshift({
      id: `AUD-${Date.now()}`,
      user: data.approvedBy || "Finance Accountant",
      role: "Accountant / Finance",
      action: "Logged Expense",
      module: "Finance",
      timestamp: new Date().toISOString().replace("T", " ").slice(0, 19),
      details: `Recorded OPEX ₹${Number(newExp.amount).toLocaleString("en-IN")} under ${newExp.category} (${newExp.paidTo})`
    });

    db.persistAll();
    return newExp;
  },

  async getReturns() {
    await delay(200);
    return [...db.returns];
  },

  async createReturn(returnData) {
    await delay(300);
    const newRet = {
      ...returnData,
      id: `RET-${Date.now()}`,
      date: returnData.date || new Date().toISOString().slice(0, 10),
      financialImpact: -Math.abs(Number(returnData.financialImpact || 0))
    };
    db.returns.unshift(newRet);

    db.auditLogs.unshift({
      id: `AUD-${Date.now()}`,
      user: "Inventory Controller",
      role: "Manager",
      action: `Processed ${newRet.type}`,
      module: "Returns & Damages",
      timestamp: new Date().toISOString().replace("T", " ").slice(0, 19),
      details: `${newRet.productName} (${newRet.qty} units) due to: ${newRet.reason}`
    });

    db.persistAll();
    return newRet;
  },

  async getEmployees() {
    await delay(200);
    return [...db.employees];
  },

  async createEmployee(empData) {
    await delay(300);
    const newEmp = {
      ...empData,
      id: `EMP-${String(db.employees.length + 1).padStart(3, "0")}`,
      status: "Active",
      advanceTaken: Number(empData.advanceTaken || 0),
      monthlySalary: Number(empData.monthlySalary || 0)
    };
    db.employees.unshift(newEmp);
    db.persistAll();
    return newEmp;
  }
};

export const auditService = {
  async getLogs() {
    await delay(150);
    return [...db.auditLogs];
  }
};
